import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Benefits } from './components/Benefits';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { FakePopup } from './components/FakePopup';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen font-inter bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        {/* Replicated compact purchase section right under hero (anchor target) */}
        <PurchaseSection id="compra" data-id="element-4" />
        <ProblemSolution data-id="element-5" />
        <WhatsIncluded data-id="element-6" />
        <Benefits data-id="element-7" />
        {/* Full purchase section with extra scarcity copy */}
        <PurchaseSection showFooter={true} data-id="element-8" />
        <Testimonials data-id="element-9" />
      </main>

      <footer className="bg-sky-900 text-sky-200 py-8 text-center text-sm" data-id="element-10">
        <div className="max-w-4xl mx-auto px-4" data-id="element-11">
          <p className="mb-2" data-id="element-12">
            © {new Date().getFullYear()} Manual Académico de Geografía. Todos
            los derechos reservados.
          </p>
          <p data-id="element-13">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <FakePopup data-id="element-14" />
      <WhatsAppButton data-id="element-15" />
    </div>;
}